import { Box } from '@material-ui/core';
import * as React from 'react';
import Markdown from 'react-markdown';

import { ConnectApiDoubleOptInPendingConsentDto } from '../../core/api/dtos';

interface ChannelItemsProps {
    pendingConsents: ConnectApiDoubleOptInPendingConsentDto[];
}

export const ChannelItems = (props: ChannelItemsProps) => {
    return (
        <Box marginLeft={3} marginTop={3}>
            {props.pendingConsents.map(({ channel, category }) => (
                <Box key={`${channel}-${category}`} marginBottom={0.5}>
                    <Markdown components={{ p: 'div' }}>
                        {`**${channel}** (${category})`}
                    </Markdown>
                </Box>
            ))}
        </Box>
    );
};
